import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const MessageService = {
  getList: async () => {
    const response = await apiService.get("/message-from-ceo");

    return response.data;
  },
  
  getbySlug: async (slug) => {
    const response = await apiService.get(
      `/message-from-ceo/by-slug/${slug}`
    );
    return response.data;
  },
};

export default MessageService;